import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/helpers/functions';
var ProtectedRoute = function (_a) {
    var Component = _a.component, isProtected = _a.isProtected;
    if (isProtected && !isAuthenticated()) {
        return _jsx(Navigate, { to: "/onboarding/welcome", replace: true });
    }
    return _jsx(Component, {});
};
export default ProtectedRoute;
